// ======================================================================
// File Name       : ArchivementSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Form, Col, Button } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import ReduxFormPaging from '../ReduxFormPaging';
import CustomButton from '../button/CustomButton';

const ArchivementSearch = (props) => {
  const { onSearchBtnClick } = props;

  return (
    <div>
      <Col sm={12} className="padding-top-10">
        <Form onSubmit={(e) => {e.preventDefault(); onSearchBtnClick();}} className='form-horizontal'>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              ログインID(添削者)
            </Col>
            <Col sm={7}>
              <RenderField
                type="text"
                name="loginId"
                maxLength="64"
                label="ログインID(添削者)"
                validates={[VALIDATE_TYPE.ID]}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              添削者名
            </Col>
            <Col sm={7}>
              <RenderField type="text" name="userName" maxLength="40" />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} as={Form.Label}>
              レポート承認日時
            </Col>
            <Col sm={3}>
              <RenderField
                type="datetime"
                name="reportApprovalDateFrom"
                validates={[VALIDATE_TYPE.DATE_TIME]}
                normalizeDateTime
              />
            </Col>
            <Col sm={1} className="text-center" as={Form.Label}>
              ～
            </Col>
            <Col sm={3}>
              <RenderField
                type="datetime"
                name="reportApprovalDateTo"
                validates={[VALIDATE_TYPE.DATE_TIME]}
                normalizeDateTime
              />
            </Col>
          </Form.Group>
          <Col sm={12}>
            <RenderField
              name="dateTimeMinMax"
              type="dateTimeMinMax"
              validates={[VALIDATE_TYPE.DATE_TIME_MIN_MAX]}
              keyDateFrom={'reportApprovalDateFrom'}
              keyDateTo={'reportApprovalDateTo'}
            />
          </Col>
          <Form.Group className="margin-top-20 text-center">
            <Col sm={12} className="text-center">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                text="検索"
                iconClass="bi bi-search"
              />
            </Col>
          </Form.Group>
        </Form>
      </Col>
      <Col sm={12} className="padding-left-right-clear">
        <Col sm={3} className="padding-left-clear margin-top-30 margin-bottom-20">
          {'添削者別　実績一覧'}
        </Col>
      </Col>
    </div>
  );
};

export default ArchivementSearch;
